var map = {
	"./Energy_Icon-0.png": 154,
	"./Mood_Icon-0.png": 155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*_Icon\-0\.png$
// module id = 262
// module chunks = 0